'use client';

import React, { useState, useEffect } from 'react';
import Navigation from './Navigation';
import BusinessProfileModal, { BusinessProfile } from './BusinessProfileModal';

interface Props {
  children: React.ReactNode;
}

export default function AppLayout({ children }: Props) {
  const [showProfileModal, setShowProfileModal] = useState(false);

  useEffect(() => {
    // Check localStorage for profile/dismissed state
    const dismissed = localStorage.getItem('smarck_profile_dismissed');
    const profile = localStorage.getItem('smarck_business_profile');
    if (!dismissed && !profile) {
      setShowProfileModal(true);
    }
  }, []);

  const handleProfileSave = (profile: BusinessProfile) => {
    localStorage.setItem('smarck_business_profile', JSON.stringify(profile));
    setShowProfileModal(false);
  };

  const handleProfileDismiss = () => {
    localStorage.setItem('smarck_profile_dismissed', 'true');
    setShowProfileModal(false);
  };

  return (
    <div className="min-h-screen" style={{ background: '#0D1B2A' }}>
      <Navigation />
      <main className="max-w-screen-2xl mx-auto px-6 lg:px-10 2xl:px-16 py-8">
        {children}
      </main>
      {showProfileModal && (
        <BusinessProfileModal
          onSave={handleProfileSave}
          onDismiss={handleProfileDismiss}
        />
      )}
    </div>
  );
}